<template>
  <div v-show="show">
    <el-form :inline="true" class="style1">
      <!-- <el-form-item>
                <el-button class="el-icon-refresh" type="text" @click="refreshData">{{$t("general.refresh")}}
                </el-button>
      </el-form-item>-->
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t("general.add")}}
        </el-button>
      </el-form-item>
    </el-form>

    <!--showing data-->
    <el-table :data="tableData" stripe highlight-current-row border style="width: 100%"
      :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('healthIns3.submission_date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.apply_date }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns3.print_no')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.emp_no }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns3.office_name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name1 }}</span>
          <span>{{ scope.row.name2 }}</span>
          <span>{{ scope.row.name3 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}</el-button>
          <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="preview(scope.$index, scope.row)" plain>
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!--adding new-->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="90%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('healthIns3.submission_date')" prop="apply_date" style="margin-left:50px">
              <el-date-picker v-model="ruleForm.apply_date" size="mini" value-format="yyyy-MM-dd"
                style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns3.submission_date')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('healthIns3.print_no')" prop="emp_no" style="margin-left:50px">
              <el-select v-model="ruleForm.emp_no" :placeholder="$t('general.select')" clearable size="mini"
                style="margin-left:10px;width: 100px">
                <el-option v-for="item in emp_no" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              &nbsp; {{$t("healthIns3.person")}}
              <el-button class="el-icon-info" type="text" @click="empNoHint"></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-collapse accordion>
          <el-collapse-item :title="$t('healthIns3.emp1')" name="1" style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id1" clearable
                      style="margin-left:10px;margin-right:50px;width: 185px" size="mini"
                      @change="employeeIdSelected(ruleForm.employee_id1,1)" :placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-select v-model="ruleForm.dependent1" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in dependent" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.payment_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.remark1" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item label="被保険者の氏名:" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name1" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" readonly>
                    </el-input>
                  </el-form-item>

                  <!-- <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item> -->

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date1" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns3.relevant_date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark1 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!--<el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday1" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-select v-model="ruleForm.type1" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post1" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address1" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn1" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-select v-model="ruleForm.reason1" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div>

                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason1 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--emp2-->
          <el-collapse-item :title="$t('healthIns3.emp2')" name="2" v-if="ruleForm.emp_no > '1'"
            style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id2" clearable
                      style="margin-left:10px;margin-right:50px;width: 185px" size="mini"
                      @change="employeeIdSelected(ruleForm.employee_id2,2)" :placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-select v-model="ruleForm.dependent2" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in dependent" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.payment_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.remark2" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item label="被保険者の氏名:" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name2" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" readonly>
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date2" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns3.relevant_date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark2 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('general.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!-- <el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday2" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-select v-model="ruleForm.type2" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post2" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address2" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn2" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-select v-model="ruleForm.reason2" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason2 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--emp3-->

          <el-collapse-item :title="$t('healthIns3.emp3')" name="3" v-if="ruleForm.emp_no > '2'"
            style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id3" clearable
                      style="margin-left:10px;margin-right:50px;width: 185px" size="mini"
                      @change="employeeIdSelected(ruleForm.employee_id3,3)" 　:placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-select v-model="ruleForm.dependent3" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in dependent" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.payment_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.remark3" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item label="被保険者の氏名:" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name3" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" readonly>
                    </el-input>
                  </el-form-item>

                  <!-- <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item> -->

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date3" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns3.relevant_date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark3 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!--  <el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday3" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-select v-model="ruleForm.types" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post3" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address3" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn3" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-select v-model="ruleForm.reason3" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason3 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('general.select')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--emp4-->

          <el-collapse-item :title="$t('healthIns3.emp4')" name="4" v-if="ruleForm.emp_no > '3'"
            style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id4" clearable
                      style="margin-left:10px;margin-right:50px;width: 185px" size="mini"
                      @change="employeeIdSelected(ruleForm.employee_id4,4)">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id" :placeholder="$t('general.select')"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-select v-model="ruleForm.dependent4" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in dependent" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.payment_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.remark4" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                  <el-form-item label="被保険者の氏名:" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name4" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" readonly>
                    </el-input>
                  </el-form-item>

                  <!-- <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item> -->

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date4" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns3.relevant_date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark4 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!--
                                    <el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday4" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-select v-model="ruleForm.type4" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post4" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address4" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn4" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-select v-model="ruleForm.reason4" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason4 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!--edit-->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="90%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition">

        <el-input type="hidden" v-model="ruleForm.id" />

        <el-row>
          <el-col :span="10">
            <el-form-item :label="$t('healthIns3.submission_date')" prop="apply_date" style="margin-left:50px">
              <el-date-picker v-model="ruleForm.apply_date" size="mini" value-format="yyyy-MM-dd"
                style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns3.submission_date')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('healthIns3.print_no')" prop="emp_no" style="margin-left:50px">
              <el-input prefix-icon="el-icon-info" v-model="ruleForm.emp_no" size="mini"
                style="margin-left:10px;width: 100px" readonly></el-input>
              &nbsp;
              {{$t("healthIns3.person")}}
              <el-button class="el-icon-info" type="text" @click="empNoHintCantChange"></el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-collapse accordion>
          <el-collapse-item :title="$t('healthIns3.emp1')" name="1" style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id1" clearable
                      style="margin-left:10px;margin-right:50px;width: 185px" size="mini"
                      @change="employeeIdSelected(ruleForm.employee_id1,1)" :placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-select v-model="ruleForm.dependent1" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in dependent" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.payment_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.remark1" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item label="被保険者の氏名:" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name1" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" readonly>
                    </el-input>
                  </el-form-item>

                  <!-- <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item> -->

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date1" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns3.relevant_date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark1 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!--<el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday1" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-select v-model="ruleForm.type1" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post1" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address1" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn1" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-select v-model="ruleForm.reason1" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div>

                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason1 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--emp2-->
          <el-collapse-item :title="$t('healthIns3.emp2')" name="2" v-if="ruleForm.emp_no > '1'"
            style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id2" clearable
                      style="margin-left:10px;margin-right:50px;width: 185px" size="mini"
                      @change="employeeIdSelected(ruleForm.employee_id2,2)" :placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-select v-model="ruleForm.dependent2" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in dependent" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.payment_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.remark2" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item label="被保険者の氏名:" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name2" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" readonly>
                    </el-input>
                  </el-form-item>

                  <!-- <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item> -->

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date2" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns3.relevant_date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark2 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('general.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!-- <el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday2" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-select v-model="ruleForm.type2" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post2" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address2" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn2" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-select v-model="ruleForm.reason2" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason2 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--emp3-->

          <el-collapse-item :title="$t('healthIns3.emp3')" name="3" v-if="ruleForm.emp_no > '2'"
            style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id3" clearable
                      style="margin-left:10px;margin-right:50px;width: 185px" size="mini"
                      @change="employeeIdSelected(ruleForm.employee_id3,3)" 　:placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-select v-model="ruleForm.dependent3" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in dependent" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.payment_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.remark3" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item label="被保険者の氏名:" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name3" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" readonly>
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date3" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns3.relevant_date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark3 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!--  <el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday3" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-select v-model="ruleForm.types" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post3" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address3" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn3" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-select v-model="ruleForm.reason3" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason3 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('general.select')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--emp4-->

          <el-collapse-item :title="$t('healthIns3.emp4')" name="4" v-if="ruleForm.emp_no > '3'"
            style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id4" clearable
                      style="margin-left:10px;margin-right:50px;width: 185px" size="mini"
                      @change="employeeIdSelected(ruleForm.employee_id4,4)">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id" :placeholder="$t('general.select')"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-select v-model="ruleForm.dependent4" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in dependent" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.payment_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.remark4" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                  <el-form-item label="被保険者の氏名:" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name4" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" readonly>
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date4" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns3.relevant_date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark4 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!--
                                    <el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday4" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-select v-model="ruleForm.type4" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post4" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address4" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address')"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn4" size="mini"
                      style="margin-left:10px;width: 625px" :placeholder="$t('healthIns3.address_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-select v-model="ruleForm.reason4" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason4 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!-- Detail -->
    <el-dialog :title="$t('healthIns3.detail')" :append-to-body="true" :visible.sync="dialogDetails" width="80%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm" size="mini"
        :label-position="labelPosition">

        <el-input type="hidden" v-model="ruleForm.id" />
        <el-row>
          <el-col :span="10">
            <el-form-item :label="$t('healthIns3.submission_date')" prop="apply_date" style="margin-left:50px">
              <el-input prefix-icon="el-icon-info" v-model="ruleForm.apply_date" size="mini"
                style="margin-left:10px;width: 185px" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('healthIns3.print_no')" prop="emp_no" style="margin-left:50px">
              <el-input prefix-icon="el-icon-info" v-model="ruleForm.emp_no" size="mini"
                style="margin-left:10px;width: 100px" readonly></el-input>
              &nbsp;
              {{$t("healthIns3.person")}}
              <el-button class="el-icon-info" type="text" @click="empNoHintCantChange"></el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-collapse accordion>
          <el-collapse-item :title="$t('healthIns3.emp1')" name="1" style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.employee_id1" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.dependent1" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.payment_amount')"
                      @change="totalSum" readonly></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.remark1" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item label="被保険者の氏名:" prop="name" :visible="false">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name1" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" disabled>
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.date1" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark1 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!--<el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday1" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.type1" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post1" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.reason1" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.address')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason1 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.address_pho')" readonly>
                    </el-input>
                  </el-form-item>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--emp2-->
          <el-collapse-item :title="$t('healthIns3.emp2')" name="2" v-if="ruleForm.emp_no > '1'"
            style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.employee_id2" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.dependent2" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.payment_amount')"
                      @change="totalSum" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.remark2" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item label="被保険者の氏名:" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name2" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" disabled>
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.date2" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark2 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('general.other')" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!-- <el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday2" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.type2" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post2" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.reason2" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.address')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason2 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.address_pho')" readonly>
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--emp3-->

          <el-collapse-item :title="$t('healthIns3.emp3')" name="3" v-if="ruleForm.emp_no > '2'"
            style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.employee_id3" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.dependent3" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.payment_amount')"
                      @change="totalSum" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.remark3" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item label="被保険者の氏名:" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name3" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" disabled>
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.date3" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark3 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!--  <el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday3" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.types" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post3" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.reason3" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.address')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason3 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('general.select')" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn3" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.address_pho')" readonly>
                    </el-input>
                  </el-form-item>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--emp4-->

          <el-collapse-item :title="$t('healthIns3.emp4')" name="4" v-if="ruleForm.emp_no > '3'"
            style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.employee_id4" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('healthIns3.dependent')" prop="dependent" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.dependent4" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.payment')" prop="payment" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.payment4" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.remark')" prop="remark" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.remark4" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                  <el-form-item label="被保険者の氏名:" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name4" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="被保険者の氏名" disabled>
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.relevant_date')" prop="date" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.date4" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.item')" prop="item" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.item4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.item_amount')"
                      @change="totalSum" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_remark')" prop="otherRemark"
                    v-if="ruleForm.remark4 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherRemark4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!--
                                    <el-form-item label="生年月日:" prop="s_birthday">
                                        <el-date-picker v-model="ruleForm.s_birthday4" size="mini"
                                            value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date"
                                            placeholder="生年月日" disabled>
                                        </el-date-picker>
                  </el-form-item>-->

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.type')" prop="type" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.type4" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.total')" prop="total" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.total4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.total')" readonly></el-input>
                    <el-button class="el-icon-info" type="text" @click="totalHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <p style="margin-left:10px; color: rgb(84, 166, 243);">
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                &emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;&emsp14;
                {{$t("healthIns3.note")}}
              </p>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.postal_code')" prop="post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.post4" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.reason')" prop="reason" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.reason4" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.address')" prop="address" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.address')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns3.other_reason')" prop="otherReason"
                    v-if="ruleForm.reason4 === 'その他'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.otherReason4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.other')" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns3.address_pho')" prop="address_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address_frgn4" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns3.address_pho')" readonly>
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="cancel()" type="primary" size="medium">{{$t("healthIns3.close")}}
        </el-button>
      </span>
    </el-dialog>

    <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>



<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        value: "",
        ruleForm: {
          id: "",
          apply_date: "",
          emp_no: "1",

          employee_id1: "",
          name1: "",
          type1: "",
          date1: "",
          dependent1: "",
          payment1: 0,
          item1: 0,
          total1: 0,
          remark1: "",
          otherRemark1: "",
          post1: "",
          address_frgn1: "",
          address1: "",
          reason1: "",
          otherReason1: "",

          employee_id2: "",
          name2: "",
          type2: "",
          date2: "",
          dependent2: "",
          payment2: 0,
          item2: 0,
          total2: 0,
          remark2: "",
          otherRemark2: "",
          post2: "",
          address_frgn2: "",
          address2: "",
          reason2: "",
          otherReason2: "",

          employee_id3: "",
          name3: "",
          type3: "",
          date3: "",
          dependent3: "",
          payment3: 0,
          item3: 0,
          total3: 0,
          remark3: "",
          otherRemark3: "",
          post3: "",
          address_frgn3: "",
          address3: "",
          reason3: "",
          otherReason3: "",

          employee_id4: "",
          name4: "",
          type4: "",
          date4: "",
          dependent4: "",
          payment4: 0,
          item4: 0,
          total4: 0,
          remark4: "",
          otherRemark4: "",
          post4: "",
          address_frgn4: "",
          address4: "",
          reason4: "",
          otherReason4: "",

          name: "",
          birthday: "",

          name1: "",
          name2: "",
          name3: "",
          chairman: "",
        },
        empList: [{
          id: "",
          employee_id: "",
          name: "",
          name_rm: "",
          name_frgn: "",
          post_code: "",
          birthday: "",
          mynum: "",
          address1: "",
          address2: "",
          address3: "",
          address_kn1: "",
          address_kn2: "",
          address_kn3: "",
          tel: "",
          pensionID: "",
          health_insuranceID: "",
          basic_pensionID: "",
          salary_month: "",
          commuting_fee: "",
        },],
        empList1: [],
        emp: {
          id: "",
          employee_id: "",
          name: "",
          name_rm: "",
          name_frgn: "",
          post_code: "",
          birthday: "",
          mynum: "",
          address1: "",
          address2: "",
          address3: "",
          address_kn1: "",
          address_kn2: "",
          address_kn3: "",
          tel: "",
          pensionID: "",
          health_insuranceID: "",
          basic_pensionID: "",
          salary_month: "",
          commuting_fee: "",
        },
        remark: [{
          value: "70歳以上被用者該当",
          label: this.$t("healthIns3.over70"),
        },
        {
          value: "二以上事業所勤務者の取得",
          label: this.$t("healthIns3.over_two"),
        },
        {
          value: "短時間労働者の取得（特定適用事業所等）",
          label: this.$t("healthIns3.part_time"),
        },
        {
          value: "退職後の継続再雇用者の取得",
          label: this.$t("healthIns3.re_emp"),
        },
        {
          value: "その他",
          label: this.$t("healthIns3.other"),
        },
        ],
        dependent: [{
          value: "無",
          label: this.$t("healthIns3.not_exist"),
        },
        {
          value: "有",
          label: this.$t("healthIns3.exist"),
        },
        ],
        type: [{
          value: "男",
          label: this.$t("healthIns3.male"),
        },
        {
          value: "女",
          label: this.$t("healthIns3.female"),
        },
        {
          value: "坑内員",
          label: this.$t("healthIns3.miner"),
        },
        {
          value: "男（基金）",
          label: this.$t("healthIns3.male_fund"),
        },
        {
          value: "女（基金）",
          label: this.$t("healthIns3.female_fund"),
        },
        {
          value: "坑内員（基金）",
          label: this.$t("healthIns3.miner_fund"),
        },
        ],
        reason: [{
          value: "海外在住",
          label: this.$t("healthIns3.oversea"),
        },
        {
          value: "短期在留",
          label: this.$t("healthIns3.short_term"),
        },
        {
          value: "その他",
          label: this.$t("healthIns3.other"),
        },
        ],
        emp_no: [{
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
        {
          value: "4",
          label: "4",
        },
        ],
        rules: {},
        tableData: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        dialogDetails: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false,
      };
    },

    methods: {
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open("/pdf/健康保険・厚生年金保険・被保険者資格取得届・厚生年金保険70歳以上被用者該当届-" + "uid=" + uid + ".pdf");
      },

      employeeIdSelected(id, number) {
        let postData = this.qs.stringify({
          employee_id: id,
        });
        this.axios({
          method: "post",
          url: "/ListEmpList",
          data: postData,
        })
          .then((response) => {
            this.empList1 = response.data;
            this.emp = this.empList1[0];
            switch (number) {
              case 1:
                this.ruleForm.name1 = this.emp.name;
                break;
              case 2:
                this.ruleForm.name2 = this.emp.name;
                break;
              case 3:
                this.ruleForm.name3 = this.emp.name;
                break;
              case 4:
                this.ruleForm.name4 = this.emp.name;
                break;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      empNoHint() {
        this.$notify.info({
          title: this.$t("healthIns3.print_no"),
          message: this.$t("healthIns3.print_noHint"),
        });
      },
      empNoHintCantChange() {
        this.$notify.info({
          title: this.$t("healthIns3.print_no"),
          message: this.$t("healthIns3.cant_change"),
        });
      },
      totalHint() {
        this.$notify.info({
          title: this.$t("healthIns3.total"),
          message: this.$t("healthIns3.totalHintMsg"),
        });
      },
      totalSum() {
        this.ruleForm.total1 =
          parseInt(this.ruleForm.payment1) + parseInt(this.ruleForm.item1);
        this.ruleForm.total2 =
          parseInt(this.ruleForm.payment2) + parseInt(this.ruleForm.item2);
        this.ruleForm.total3 =
          parseInt(this.ruleForm.payment3) + parseInt(this.ruleForm.item3);
        this.ruleForm.total4 =
          parseInt(this.ruleForm.payment4) + parseInt(this.ruleForm.item4);
      },
      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id,
        });
        this.axios({
          method: "post",
          url: "/healthIns3PDF",
          data: postData,
        })
          .then((response) => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed"),
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 700);
            // console.log(response);
          })
          .catch((error) => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed"),
            });
            console.log(error);
          });
      },

      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDetails(index, row) {
        this.dialogDetails = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        })
          .then(_ => {
            this.emptyUserData();
            done();
          })
          .catch(_ => { });
      },
      handleCurrentChange() {
        // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
        let postData = this.qs.stringify({
          page: this.currentPage,
        });
        this.axios({
          method: "post",
          url: "/pageHealthIns3",
          data: postData,
        })
          .then((response) => {
            this.tableData = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },

      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
      },

      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: "OK",
          cancelButtonText: this.$t("general.cancel"),
          type: "warning",
        })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id,
            });
            this.axios({
              method: "post",
              url: "/deleteHealthIns3",
              data: postData,
            })
              .then((response) => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageHealthIns3")
                  .then((response) => {
                    this.tableData = response.data;
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled"),
            });
          });
      },

      emptyUserData() {
        this.ruleForm = {
          id: "",
          apply_date: "",
          emp_no: "1",

          employee_id1: "",
          name1: "",
          type1: "",
          date1: "",
          dependent1: "",
          payment1: 0,
          item1: 0,
          total1: 0,
          remark1: "",
          otherRemark1: "",
          post1: "",
          address_frgn1: "",
          address1: "",
          reason1: "",
          otherReason1: "",

          employee_id2: "",
          name2: "",
          type2: "",
          date2: "",
          dependent2: "",
          payment2: 0,
          item2: 0,
          total2: 0,
          remark2: "",
          otherRemark2: "",
          post2: "",
          address_frgn2: "",
          address2: "",
          reason2: "",
          otherReason2: "",

          employee_id3: "",
          name3: "",
          type3: "",
          date3: "",
          dependent3: "",
          payment3: 0,
          item3: 0,
          total3: 0,
          remark3: "",
          otherRemark3: "",
          post3: "",
          address_frgn3: "",
          address3: "",
          reason3: "",
          otherReason3: "",

          employee_id4: "",
          name4: "",
          type4: "",
          date4: "",
          dependent4: "",
          payment4: 0,
          item4: 0,
          total4: 0,
          remark4: "",
          otherRemark4: "",
          post4: "",
          address_frgn4: "",
          address4: "",
          reason4: "",
          otherReason4: "",

          name: "",
          birthday: "",
        };
      },

      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              apply_date: this.ruleForm.apply_date,
              emp_no: this.ruleForm.emp_no,

              employee_id1: this.ruleForm.employee_id1,
              type1: this.ruleForm.type1,
              date1: this.ruleForm.date1,
              dependent1: this.ruleForm.dependent1,
              payment1: this.ruleForm.payment1,
              item1: this.ruleForm.item1,
              total1: this.ruleForm.total1,
              remark1: this.ruleForm.remark1,
              otherRemark1: this.ruleForm.otherRemark1,
              post1: this.ruleForm.post1,
              address_frgn1: this.ruleForm.address_frgn1,
              address1: this.ruleForm.address1,
              reason1: this.ruleForm.reason1,
              otherReason1: this.ruleForm.otherReason1,

              employee_id2: this.ruleForm.employee_id2,
              type2: this.ruleForm.type2,
              date2: this.ruleForm.date2,
              dependent2: this.ruleForm.dependent2,
              payment2: this.ruleForm.payment2,
              item2: this.ruleForm.item2,
              total2: this.ruleForm.total2,
              remark2: this.ruleForm.remark2,
              otherRemark2: this.ruleForm.otherRemark2,
              post2: this.ruleForm.post2,
              address_frgn2: this.ruleForm.address_frgn2,
              address2: this.ruleForm.address2,
              reason2: this.ruleForm.reason2,
              otherReason2: this.ruleForm.otherReason2,

              employee_id3: this.ruleForm.employee_id3,
              type3: this.ruleForm.type3,
              date3: this.ruleForm.date3,
              dependent3: this.ruleForm.dependent3,
              payment3: this.ruleForm.payment3,
              item3: this.ruleForm.item3,
              total3: this.ruleForm.total3,
              remark3: this.ruleForm.remark3,
              otherRemark3: this.ruleForm.otherRemark3,
              post3: this.ruleForm.post3,
              address_frgn3: this.ruleForm.address_frgn3,
              address3: this.ruleForm.address3,
              reason3: this.ruleForm.reason3,
              otherReason3: this.ruleForm.otherReason3,

              employee_id4: this.ruleForm.employee_id4,
              type4: this.ruleForm.type4,
              date4: this.ruleForm.date4,
              dependent4: this.ruleForm.dependent4,
              payment4: this.ruleForm.payment4,
              item4: this.ruleForm.item4,
              total4: this.ruleForm.total4,
              remark4: this.ruleForm.remark4,
              otherRemark4: this.ruleForm.otherRemark4,
              post4: this.ruleForm.post4,
              address_frgn4: this.ruleForm.address_frgn4,
              address4: this.ruleForm.address4,
              reason4: this.ruleForm.reason4,
              otherReason4: this.ruleForm.otherReason4,
            });
            this.axios({
              method: "post",
              url: "/insertHealthIns3",
              data: postData,
            })
              .then((response) => {
                this.axios
                  .post("/pageHealthIns3")
                  .then((response) => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.cancel();
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed"),
                    });
                  })
                  .catch((error) => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed"),
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },

      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              apply_date: this.ruleForm.apply_date,
              emp_no: this.ruleForm.emp_no,

              employee_id1: this.ruleForm.employee_id1,
              type1: this.ruleForm.type1,
              date1: this.ruleForm.date1,
              dependent1: this.ruleForm.dependent1,
              payment1: this.ruleForm.payment1,
              item1: this.ruleForm.item1,
              total1: this.ruleForm.total1,
              remark1: this.ruleForm.remark1,
              otherRemark1: this.ruleForm.otherRemark1,
              post1: this.ruleForm.post1,
              address_frgn1: this.ruleForm.address_frgn1,
              address1: this.ruleForm.address1,
              reason1: this.ruleForm.reason1,
              otherReason1: this.ruleForm.otherReason1,

              employee_id2: this.ruleForm.employee_id2,
              type2: this.ruleForm.type2,
              date2: this.ruleForm.date2,
              dependent2: this.ruleForm.dependent2,
              payment2: this.ruleForm.payment2,
              item2: this.ruleForm.item2,
              total2: this.ruleForm.total2,
              remark2: this.ruleForm.remark2,
              otherRemark2: this.ruleForm.otherRemark2,
              post2: this.ruleForm.post2,
              address_frgn2: this.ruleForm.address_frgn2,
              address2: this.ruleForm.address2,
              reason2: this.ruleForm.reason2,
              otherReason2: this.ruleForm.otherReason2,

              employee_id3: this.ruleForm.employee_id3,
              type3: this.ruleForm.type3,
              date3: this.ruleForm.date3,
              dependent3: this.ruleForm.dependent3,
              payment3: this.ruleForm.payment3,
              item3: this.ruleForm.item3,
              total3: this.ruleForm.total3,
              remark3: this.ruleForm.remark3,
              otherRemark3: this.ruleForm.otherRemark3,
              post3: this.ruleForm.post3,
              address_frgn3: this.ruleForm.address_frgn3,
              address3: this.ruleForm.address3,
              reason3: this.ruleForm.reason3,
              otherReason3: this.ruleForm.otherReason3,

              employee_id4: this.ruleForm.employee_id4,
              type4: this.ruleForm.type4,
              date4: this.ruleForm.date4,
              dependent4: this.ruleForm.dependent4,
              payment4: this.ruleForm.payment4,
              item4: this.ruleForm.item4,
              total4: this.ruleForm.total4,
              remark4: this.ruleForm.remark4,
              otherRemark4: this.ruleForm.otherRemark4,
              post4: this.ruleForm.post4,
              address_frgn4: this.ruleForm.address_frgn4,
              address4: this.ruleForm.address4,
              reason4: this.ruleForm.reason4,
              otherReason4: this.ruleForm.otherReason4,
            });
            this.axios({
              method: "post",
              url: "/updateHealthIns3",
              data: postData,
            })
              .then((response) => {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed"),
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },

      getPages() {
        this.axios
          .post("/rowsHealthIns3")
          .then((response) => {
            this.total = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      },
    },

    created() {
      this.axios
        .post("/pageHealthIns3")
        .then((response) => {
          // console.log(response.data);
          this.show = true;
          this.tableData = response.data;
        })
        .catch((error) => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });

      this.axios
        .post("/rowsHealthIns3")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios
        .post("/ListEmpListForInsNameChange")
        .then((response) => {
          // console.log(response.data);
          this.empList = response.data;
          // console.log(this.empList);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/HealthIns/HealthIns3.vue